<template>
  <el-dialog
    class="modal-batch-stores"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="content">
      <el-form
        ref="batchStores"
        v-loading="isLoading"
        label-position="right"
        @submit.native.prevent
        class="batch-stores__form"
      >
        <el-form-item label="选择对接系统:" prop="brandName">
          <div class="table-list">
            <table>
              <thead>
                <tr>
                  <td>对接系统</td>
                  <td width="280">接口流向
                    <el-tooltip placement="top">
                      <div slot="content">请求中台：对接系统⟶中台⟶第三方系统<br>中台推送：对接系统⟵中台⟵第三方系统</div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in sysList" :key="item.id">
                  <td>{{item.systemName}}</td>
                  <td>
                    <el-checkbox-group v-model="item.selectList" size="mini" @change="changeType($event, item)">
                      <el-checkbox :label="1" border>请求中台</el-checkbox>
                      <el-checkbox :label="2" border>中台推送</el-checkbox>
                    </el-checkbox-group>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="save__btn" @click="$_submit">保存</el-button>
      <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>

export default {
  name: "modal-batch",
  props: {
    title: { type: String, default: "" },
    modalData: { type: Array, default: () => [] },
    isSubmitPost: {//直接提交服务端
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      sysList: []
    };
  },
  methods: {
    $_submit() {
      const systemDockingInfos = this.sysList.filter(item => item.dockingFlowType !== '').map(item => {
        const { dockingFlowType, id, iconOfSendZt, iconOfZtPush, iconOfSendAndPush } = item
        return {
          iconOfSendZt, 
          iconOfZtPush, 
          iconOfSendAndPush,
          dockingFlowType,
          dockingSystemId: id
        }
      })
      if(this.isSubmitPost){//直接提交
        // 
        const self = this;
        $MessageBox.confirm({
          content: `
            <div>该操作会覆盖历史的接口字段对接且对选中接口的所有字段有效；</div>
          `,
          onOk() {
            self.isLoading = true;
            self.$service.post("portDockingInfoBatchSave", {
              pidList: self.modalData,
              systemDockingInfos: systemDockingInfos.length ? systemDockingInfos : null
            }).then(result => {
              self.isLoading = false;
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    self.visible = false;
                    self.$emit("callback");
                  }
                });
              }
            });
          }
        });
      }else{
        this.$emit("callback", systemDockingInfos);
        this.$_cancle();
      }
    },
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
    $_getApis() {
      this.isLoading = true;
      this.$service.post("dockingSystemGetAll").then(result => {
        this.isLoading = false;
        if (result.$.checkResult(result, true)) {
          this.sysList = result.data.map(item => {
            item.selectList = []
            item.dockingFlowType = ''
            return item
          });
        }
      });
    },
    changeType(val, item){
      if(val.length === 0){
        item.dockingFlowType = ''
        return false
      }
      if(val.length === 2){
        item.dockingFlowType = 3
      }else{
        item.dockingFlowType = val[0]
      }
    }
  },
  created() {
    this.$_getApis()
  },
  mounted() {
    this.visible = true;
  }
};
</script>

<style lang="scss" scoped>
.batch-stores__form {
  padding: {
    left: 20px;
  }
}
.content {
  padding: 20px 20px;
  color: #535353;
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
    font-weight: 700;
  }
  .table-list{
    background-color: #fff;
    padding: 20px;
    table{
      width: 100%;
      border: 1px solid #BCCAD0;
      border-collapse:collapse;
      text-align: center;
      td{
        word-break: break-all;
        border: 1px solid #BCCAD0;
        padding: 6px 14px;
        line-height: 16px;
        .el-checkbox + .el-checkbox{
          margin-left: 20px;
        }
      }
    }
  }
  .el-icon-question {
    margin: {
      left: 4px;
    }
    vertical-align: middle;
    font-size: 16px;
    color: #ccc;
    cursor: pointer;
  }
}
</style>


